module.exports = __webpack_public_path__ + "img/linkedin 2.1566dcff.svg";